import React, { useMemo } from 'react'
import './About.css'
import Heading from '../../common/heading/Heading'

const About = () => {
	const now = new Date()
	const base = new Date('2020-04-01')

	const year = useMemo(() => {
		let diff = now.getFullYear() - base.getFullYear()
		if (now.getMonth() < 3) diff--
		return diff
	}, [now])

	const yearText = useMemo(() => {
		const displayYear = year + 1
		if (displayYear === 1) return '1st'
		if (displayYear === 2) return '2nd'
		if (displayYear === 3) return '3rd'
		return `${displayYear}th`
	}, [year])

	return (
    <section className="about-section">
      <div className="about-inner text-block">
        <div className="about-grid">
          <div className="about-heading-col">
            <Heading eyebrow="Our story">About Us</Heading>
            {/* <div className='year-badge'>
							<span className='year-num'>{yearText}</span>
							<span className='year-label'>Year serving DFW</span>
						</div> */}
          </div>

          <div className="about-text-col">
            <p className="emphasis">
              GW Motorsports LLC is now proudly in our 7th year of serving
              customers and motorcycle enthusiasts in the DFW area and
              nationwide.
            </p>
            <p>
              Our full-time technicians take pride in their work and are experts
              in their specialized fields of diagnostics, repair, installation
              and tuning.
            </p>
            <p className="callout">
              Quality and attention to detail is our #1 priority — reflected in
              every vehicle that leaves our shop.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About
